import { useState } from 'react';
import { useTranslate } from '@refinedev/core';
import { List } from '@refinedev/antd';
import { Space, InputNumber, Button, Typography, Input } from 'antd';
import { IssuedLicencesPanel } from '@/components/account/IssuedLicencesPanel';

export const IssuedLicencesList = () => {
  const t = useTranslate();
  const [accountId, setAccountId] = useState<number | null>(null);
  const [emailQuery, setEmailQuery] = useState('');
  const accountIds = accountId != null ? [accountId] : [];

  return (
    <List canCreate={false}>
      <Typography.Paragraph type="secondary" style={{ marginBottom: 16 }}>
        {t('account.licences.page_intro')}
      </Typography.Paragraph>
      <Space wrap style={{ marginBottom: 24 }}>
        <Space>
          <span>{t('account.licences.account_id_label')}</span>
          <InputNumber
            min={1}
            value={accountId ?? undefined}
            onChange={(v) => setAccountId(typeof v === 'number' ? v : null)}
          />
        </Space>
        <Space>
          <span>{t('account.licences.account_email_label')}</span>
          <Input
            placeholder={t('account.licences.account_email_placeholder')}
            value={emailQuery}
            onChange={(event) => setEmailQuery(event.target.value)}
            style={{ width: 280 }}
          />
        </Space>
        <Button
          type="default"
          onClick={() => {
            setAccountId(null);
            setEmailQuery('');
          }}
        >
          {t('account.licences.clear_filters')}
        </Button>
      </Space>

      <IssuedLicencesPanel
        accountIds={accountIds}
        allowAllWhenNoAccount
        accountEmailQuery={emailQuery}
      />
    </List>
  );
};
